import React, { Component, Fragment } from 'react';
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import * as Func from '../../../../../helpers/functions';
import i18n from "../../../../../constants/initLng";
import action from "../../../../../actions";
import * as bannerActions from "../../../../../actions/bannerAction";
import DEFINE, { BANNER, DETAIL_ACTIONS, PATHS, FEATURE_FLAGS, UPLOAD } from '../../../../../constants/Define';
import * as HMS from "../../../common/component/Index";
import { message, Tooltip, Icon } from 'antd';
import Input from '../../../common/component/Input';
import AntSelect, { AntOption } from '../../../common/component/AntSelect';
import UploadImage from '../../../common/component/UploadImage';
import $ from 'jquery'
import { omit, merge, cloneDeep } from 'lodash';
import TranslateButton from '../../../common/component/TranslateButton';
import Banner from "../../../../../models/Banner";
import { detectMimeFromMagicBytes, readableFileSize } from '../../../../../utils/commonUtils';

const BANNER_IMAGE_TYPES = ['image/jpeg', 'image/jpg', 'image/png'];

const defaultValue = {
    action: DETAIL_ACTIONS.CREATE,
    data: merge(new Banner(), { isEnabled: true }),
    allProperties: [],
    isSubmit: false,
    isFetching: false,
    isFetchingUpdate: false,
    isGetItem: false,
    validation: {},
    isUpload: false,
};

class ActionComponent extends Component {

    state = cloneDeep(defaultValue);

    componentDidMount() {
        const { match } = this.props;
        if (Object.keys(match.params).length > 0) {
            this.setState({ action: DETAIL_ACTIONS.UPDATE, data: cloneDeep(defaultValue.data) });
            this.props.onGetItemUser({ id: match.params.id, props: this.props });
        }
    }

    validation = (field, reload) => {
        const { t } = this.props;
        let data = cloneDeep(this.state.data);
        let result = {};
        if (!reload) {
            let validate = {
                isUrl: { url: t('validation.isUrl') },
                required: {
                    filename: Func.formatValidation(t('validation.statusCode.code.1'), t(`item.banner.image`)),
                    order: t('validation.statusCode.code.1'),
                    name: t('validation.statusCode.code.1'),
                    type: t('validation.statusCode.code.1'),
                }
            };
            if (this.state.action === DETAIL_ACTIONS.CREATE) {
                validate.required.languageCode = Func.formatValidation(t('validation.statusCode.code.1'), t(`translate.defaultLanguage`));
            }
            let valueValidate = {};
            result = Func.multipleValidate(data, validate, valueValidate);
        } else {
            let validation = this.state.validation;
            result = Func.reloadValidation(validation, field)
        }
        this.setState({ validation: result });
        return result;
    };

    componentWillReceiveProps(nextProps) {
        this.setState({
            isSubmit: nextProps.banners.isSubmit,
            isGetItem: nextProps.banners.isGetItem,
            isUpload: nextProps.file.isFetching,
            isFetchingUpdate: nextProps.banners.isFetchingUpdate
        })
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.props.file !== prevProps.file) {
            if (this.props.file.file) {
                const data = cloneDeep(this.state.data);
                data.filename = this.props.file.file.data.fileName;
                data.imageView = { filename: this.props.file.file.data.fileName, fileUri: this.props.file.file.data.fileUrl };
                const validation = Func.reloadValidation(this.state.validation, 'filename');
                this.setState({
                    file: this.props.file.file, data, validation,
                });
            }
        }
        if (this.props.banners.dataUpdate !== prevProps.banners.dataUpdate) {
            this.setState({
                data: this.props.banners.dataUpdate,
            })
        }
    }

    onShowTranslate = (language) => {
        const data = cloneDeep(this.state.data);
        data.setTranslate(language.code);
        data.setData();
        this.setState({ data, action: DETAIL_ACTIONS.TRANSLATE });
    }

    onExitTranslate = () => {
        const data = cloneDeep(this.state.data);
        const action = DETAIL_ACTIONS[data.id ? 'UPDATE' : 'CREATE'];
        data.setTranslate(undefined, true);
        data.setData();
        this.setState({ data, action });
    }

    onClickBack = () => {
        if (this.state.action === DETAIL_ACTIONS.TRANSLATE) {
            this.onExitTranslate();
        } else {
            this.props.history.push(PATHS.BANNER.LIST.path);
        }
    }

    onSaveTranslate = (data) => {
        data = data || this.state.data;
    
        const translateFunction = data.translate.id ? this.props.updateBannerTranslate : this.props.createBannerTranslate;
        translateFunction(data, data.languageCode);
        this.onExitTranslate();
    }

    onRemoveTranslate = (language) => {
        const { data } = this.state;
        data.setTranslate(language.code);
        this.props.deleteBannerCategoryTranslate(data, { id: data.id });
    }

    onChange = (e, params) => {
        const processStringValue = (name, value) => {
            if (name === 'imageId') {
                return value.replace(/[^\w\s]/gi, '')
            }
            return value.trimLeft()
        }
        params = params || Func.getValueForm(e);
        const data = cloneDeep(this.state.data);
        data[params.name] = typeof params.value === 'string' ? processStringValue(params.name, params.value) : params.value;
        this.setState({ data });
        this.validation(params.name, true)
    };

    onSubmit = (e) => {
        e.preventDefault();
        let result = this.validation();
        if (Object.keys(result).length < 1) {
            if (this.state.action === DETAIL_ACTIONS.CREATE) {
                // let dataCreate = Models.usersActionModel(this.state.data);
                const dataCreate = this.state.data;
                dataCreate.name = this.state.data.name;
                // if (this.state.isDisableStation) {
                //     dataCreate = Func.removeElementObject(dataCreate, 'stationId')
                // }
                this.props.onCreateBanner({ data: dataCreate, props: this.props });
            } else if (this.state.action === DETAIL_ACTIONS.UPDATE) {
                // let dataUpdate = Models.usersActionModel(this.state.data);
                const dataUpdate = this.state.data;
                dataUpdate.name = this.state.data.name;
                dataUpdate.id = this.state.data.id;
                // if (this.state.isDisableStation) {
                //     dataUpdate = Func.removeElementObject(dataUpdate, 'stationId')
                // }
                this.props.onUpdateBanner({ data: dataUpdate, props: this.props });
            } else if(this.state.action === DETAIL_ACTIONS.TRANSLATE){
                this.onSaveTranslate()
            }
        } else {
            message.error(i18n.t('validation.checkForm'))
        }
    };

    uploadFile = async (file) => {
        const selectedFile = file.target.files && file.target.files[0];
        if (!selectedFile) return false;

        const typeFile = await detectMimeFromMagicBytes(selectedFile);
        if (!BANNER_IMAGE_TYPES.includes(typeFile)) {
            message.error(i18n.t('validation.image'));
            return false;
        }

        if (selectedFile.size > UPLOAD.MAX_FILE_SIZE) {
            message.error(`${i18n.t('validation.statusCode.code.FILE_LENGTH_OVER_LIMIT')}. ${i18n.t('notification.maxFileSize')}: ${readableFileSize(UPLOAD.MAX_FILE_SIZE, 0)}`);
            return false;
        }

        const data = cloneDeep(this.state.data);
        data.imageView = undefined;
        this.setState({
            isUpload: true,
            data: data
        });
        this.props.onUploadFile({ file: selectedFile, directory: "sliders", isFile: 1 });
    };

    onRemoveImage = () => {
        const data = cloneDeep(this.state.data);
        data.filename = undefined;
        data.imageView = undefined;

        this.setState({
            data,
            file: undefined,
        });
    }

    render() {
        const { t } = this.props;
        const { data, validation, isSubmit, isGetItem, action, isUpload, file } = this.state;
        return (
            <Fragment>
                <HMS.LoadingComponent spinning={isSubmit}>
                    <HMS.PageListComponent>
                        <HMS.HeaderListComponent
                            path={this.props.match.path}
                            groupPath={'banners'}
                            titleHeader={
                                action === "CREATE" ?
                                    Func.capitalizeFirstLetter((`${t('action.create')} ${t('item.banner.title')}`).toLowerCase())
                                    : Func.capitalizeFirstLetter((`${t('action.update')} ${t('item.banner.title')}`.toLowerCase()))
                            }
                            componentRight={FEATURE_FLAGS.TRANSLATE_ENABLE &&
                                <TranslateButton
                                    languages={data.translations}
                                    current={data.languageCode}
                                    validation={validation.languageCode}
                                    onChange={this.onShowTranslate}
                                    onClear={this.onExitTranslate}
                                    defaultSelecting={action === DETAIL_ACTIONS.CREATE}
                                    onSelectDefault={language => this.onChange({}, {value: language.code, name: 'languageCode'})}
                                    onRemove={this.onRemoveTranslate} />
                            }
                        />
                        <HMS.FormActionComponent
                            onSubmit={this.onSubmit}
                            isSubmit={isSubmit}
                            action={action}
                            isGetItem={isGetItem}
                            findParentRoute={() => Func.findParentRoute('banners', this.props)}
                            activeComponent={true}
                            onChangeActive={this.onChange}
                            titleActiveComponent={t(`item.banner.active`)}
                            submitButtonRight={true}
                            statusActiveName={`isEnabled`}
                            statusActive={data.isEnabled}
                            onClickBack={this.onClickBack}
                            backButtonText={action === DETAIL_ACTIONS.TRANSLATE ? t(`action.cancel`) : t(`action.back`)}
                            titleButtonSubmit={action === DETAIL_ACTIONS.TRANSLATE ? t(`action.save`) : undefined}
                        >
                            <HMS.FormWrapperItem>
                                <div className={`col-md-5`}>

                                    <HMS.FormWrapperInputComponent
                                        isRequired={true}
                                        isValidation={true}
                                        dataValidation={data.filename}
                                        validation={validation.filename}
                                        labelTitle={t(`item.banner.image`)}
                                    >
                                        <UploadImage
                                            multiple={false}
                                            accept=".jpg,.jpeg,.png"
                                            loading={isUpload}
                                            thumbnailSize="100%"
                                            buttonSize={120}
                                            disabledRemove={false}
                                            onRemoveThumbnail={this.onRemoveImage}
                                            thumbnailStyle={{ maxHeight: 250 }}
                                            uploadText={t('item.tour.uploadFile')}
                                            loadingText={t('item.tour.uploading')}
                                            onChange={this.uploadFile}
                                            thumbnails={file || data.imageView ? [`${DEFINE.GENERAL.CDN_IMG_DEFAULT}${!data.imageView.fileUri ? file.data.fileUri : data.imageView.fileUri}`] : undefined} />
                                    </HMS.FormWrapperInputComponent>
                                </div>
                                <div className={`col-md-7`}>
                                    <HMS.FormWrapperInputComponent
                                        isRequired={true}
                                        isValidation={true}
                                        dataValidation={data.name}
                                        validation={validation.name}
                                        labelTitle={t(`item.banner.name`)}
                                    >
                                        <Input placeholder="" type={`text`}
                                            className={`form-control`}
                                            name={`name`} onChange={this.onChange}
                                            value={Func.checkUndefine(data.name)} />
                                    </HMS.FormWrapperInputComponent>
                                    <HMS.FormWrapperInputComponent
                                        dataValidation={data.url}
                                        validation={validation.url}
                                        labelTitle={t(`item.banner.url`)}
                                    >
                                        <Input placeholder="" type={`text`}
                                            className={`form-control`}
                                            name={`url`} onChange={this.onChange}
                                            value={Func.checkUndefine(data.url)} />
                                    </HMS.FormWrapperInputComponent>
                                    <HMS.FormWrapperInputComponent
                                        isRequired={true}
                                        isValidation={true}
                                        dataValidation={data.order}
                                        validation={validation.order}
                                        labelTitle={t(`item.banner.order`)}
                                        visible={action !== DETAIL_ACTIONS.TRANSLATE}
                                    >
                                        <Input placeholder="" type={`text`}
                                            className={`form-control`}
                                            name={`order`} onChange={this.onChange}
                                            value={Func.checkUndefine(data.order)} />
                                    </HMS.FormWrapperInputComponent>
                                    <HMS.FormWrapperInputComponent
                                        isRequired={true}
                                        isValidation={true}
                                        dataValidation={data.type}
                                        validation={validation.type}
                                        labelTitle={t(`item.banner.type`)}
                                        visible={action !== DETAIL_ACTIONS.TRANSLATE}
                                    >
                                        <AntSelect className="select-type"
                                            showArrow
                                            placeholder={Func.capitalizeFirstLetter((t('placeHolderForm.select') + " " + t("item.banner.type")).toLowerCase())}
                                            value={data.type}
                                            onChange={this.onChangeType}
                                            style={{ width: '100%' }}
                                        >
                                            {Object.keys(BANNER.TYPES).map(key => (
                                                <AntOption key={BANNER.TYPES[key].id} value={BANNER.TYPES[key].id}>{t(`item.${BANNER.TYPES[key].id}.title`)}</AntOption>
                                            ))}
                                        </AntSelect>
                                    </HMS.FormWrapperInputComponent>
                                    <HMS.FormWrapperInputComponent
                                        labelTitle={t(`item.banner.imageId`)}
                                        visible={action !== DETAIL_ACTIONS.TRANSLATE}
                                    >
                                        {/* <Input placeholder="" type={`text`}
                                            className={`form-control`}
                                            name={`imageId`} onChange={this.onChange}
                                            value={Func.checkUndefine(data.imageId)} /> */}
                                        <AntSelect className="select-type"
                                            allowClear
                                            value={Func.checkUndefine(data.imageId)}
                                            showSearch autoClearSearchValue={false} showArrow={false}
                                            optionFilterProp="children"
                                            onBlur={() => this.onChange({}, { name: 'imageId', value: data.imageId })}
                                            onChange={(id) => this.onChange({}, { name: 'imageId', value: id })}
                                            onSearch={value => this.onChange({}, { name: 'imageId', value })}
                                            filterOption={(input, option) =>
                                                option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                            }
                                            style={{ width: '100%' }}
                                        >
                                            {BANNER.IMAGE_IDS.map(id => (
                                                <AntOption key={id} value={id}>{t(`item.banner.imageIds.${id}`)}</AntOption>
                                            ))}
                                        </AntSelect>
                                    </HMS.FormWrapperInputComponent>
                                </div>
                            </HMS.FormWrapperItem>
                        </HMS.FormActionComponent>
                    </HMS.PageListComponent>
                </HMS.LoadingComponent>
            </Fragment>
        );
    }

    onChangeType = (typeId) => {
        let data = this.state.data;
        data.type = typeId;
        this.setState({ data })
    }
}

const mapStateToProps = state => {
    return {
        banners: state.bannerReducer,
        file: state.uploadReducer,
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        onUploadFile: (filters) => {
            dispatch(action.uploadAction(filters))
        },
        onCreateBanner: (params) => {
            dispatch(action.createBannerAction(params))
        },
        onUpdateBanner: (id) => {
            dispatch(action.updateBannerAction(id))
        },
        onGetItemUser: (id) => {
            dispatch(action.getUpdateBannerAction(id))
        },
        createBannerTranslate: (banner, language) => dispatch(bannerActions.createBannerTranslate(banner, language)),
        updateBannerTranslate: (banner, language) => dispatch(bannerActions.updateBannerTranslate(banner, language)),
        deleteBannerTranslate: (banner, refreshParams) => dispatch(bannerActions.deleteBannerTranslate(banner, refreshParams)),
    }
};

export default withTranslation()(connect(mapStateToProps, mapDispatchToProps)(withTranslation()(ActionComponent)));
